/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Haveaccount1Inputs */

const he_auth_signup_haveaccount1 = /** @type {(inputs: Auth_Signup_Haveaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יש לכם כבר חשבון?`)
};

const en_auth_signup_haveaccount1 = /** @type {(inputs: Auth_Signup_Haveaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already have an account?`)
};

/**
* | output |
* | --- |
* | "Already have an account?" |
*
* @param {Auth_Signup_Haveaccount1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const auth_signup_haveaccount1 = /** @type {((inputs?: Auth_Signup_Haveaccount1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Haveaccount1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_signup_haveaccount1(inputs)
	return en_auth_signup_haveaccount1(inputs)
});
export { auth_signup_haveaccount1 as "auth_signup_haveAccount" }